import { useEffect, useState } from 'react';
import UnassignTenantModalEventManager, { UnassignTenantModalCustomEventType, UnassignTenantModalEventData } from '../../../componentsNew/organisms/modal/UnassignTenantModalEventManager';
import Modal from '../../organisms/modal/Modal';
import styles from './UnassignTenantModal.module.css';
import ColorEnum from '../../../enums/colorEnum';
import { Trans, useTranslation } from 'react-i18next';
import Text from '../../../componentsNew/atoms/typography/Text';
import { FontSizeEnum, ColorEnum as ColorEnumNew, FontWeightEnum } from '../../../componentsNew/enums';
import ButtonNew from '../../../componentsNew/molecules/button/Button';
import unassignTenantFromListing from '../../../api/transactional-listing/unassignTenantFromListing';
import Notifications from '../../../componentsNew/organisms/notifications/Notifications';

const unassignTenantModal = UnassignTenantModalEventManager.create<UnassignTenantModalEventData>('unassign_tenant');

type UnassignTenantModalComponent = () => JSX.Element;

const UnassignTenantModal = () => {
    const { t } = useTranslation();

    const [transactionalListingId, setTransactionalListingId] = useState<string>('');
    const [homeseekerApplicationId, setHomeseekerApplicationId] = useState<string>('');
    const [fullName, setFullName] = useState<string>('');

    const setUnassignTenantModalData = (e: UnassignTenantModalCustomEventType) => {
        setFullName(e.detail.fullName);
        setTransactionalListingId(e.detail.transactionalListingId);
        setHomeseekerApplicationId(e.detail.homeseekerApplicationId);
    }

    const handleUnassignTenantModalClose = () => {
        unassignTenantModal.close();
    }

    const handleUnassignTenant = async () => {
        try {
            await unassignTenantFromListing({
                transactionalListingId: transactionalListingId,
                homeseekerApplicationId: homeseekerApplicationId
            });

            handleUnassignTenantModalClose();

            Notifications.add({
                type: 'success',
                message: (
                    <Trans
                        i18nKey="candidate.unassign.toast.success"
                        values={{ tenant: fullName }}
                        components={{ strong: <strong /> }}
                    />
                )
            });
        } catch (e) {
            Notifications.add({
                type: 'failed',
                message: t('candidate.unassign.toast.failed')
            });
        }
    }

    useEffect(() => {
        unassignTenantModal.addListener(setUnassignTenantModalData);

        return () => {
            unassignTenantModal.removeListener(setUnassignTenantModalData);
        }
    }, []);

    return (
        <Modal
            isOpen={false}
            flowyColor={ColorEnum.Primary100}
            icon={'ri-user-unfollow-line'}
            onCloseButtonClick={handleUnassignTenantModalClose}
            iconColor={ColorEnum.Primary600}
            iconBackgroundColor={ColorEnum.Primary100}
            canOverflow={true}
            isNonScrollable={true}
            manager={unassignTenantModal}
        >
            <div className={styles.unassignTenantContainer}>
                <Text
                    size={FontSizeEnum.Md}
                    color={ColorEnumNew.Gray900}
                    weight={FontWeightEnum.Bold}
                >
                    {t('candidate.unassign.title', {
                        tenant: fullName
                    })}
                </Text>
                <Text
                    color={ColorEnumNew.Gray800}
                >
                    {t('candidate.unassign.subtext')}
                </Text>
                <Text
                    color={ColorEnumNew.Gray800}
                >
                    {t('candidate.unassign.body', {
                        tenant: fullName
                    })}
                </Text>
                <div className={styles.buttonsContainer}>
                    <ButtonNew
                        variant='secondary-gray'
                        onClick={handleUnassignTenantModalClose}
                    >
                        {t('actions.cancel')}
                    </ButtonNew>
                    <ButtonNew
                        onClick={handleUnassignTenant}
                    >
                        {t('listings.unarchive.modal.deleteTenant')}
                    </ButtonNew>
                </div>
            </div>
        </Modal>
    )
}

Object.assign(UnassignTenantModal, unassignTenantModal);

export default (UnassignTenantModal as UnassignTenantModalComponent & UnassignTenantModalEventManager<UnassignTenantModalEventData>);
